import { Transformation } from '@pi/transformer-compiler';
// eslint-disable-next-line no-restricted-imports
import { api } from '@pi/api-client';
import memoizeExpire from 'src/utils/memoizeExpire';

export default function setupTransformerCompiler(): void {
    Transformation.setGlobalOptions({
        fetchResource,
        fetchDocument,
        fetchAttributeSchema,
        fetchDocumentByQuery,
    });
}

const fetchResource = memoizeExpire({
    timeout: 60e3,
    func: (id: string, isFormulaResource?: boolean) => {
        if (isFormulaResource) {
            return api
                .model('FormulaResource')
                .findById(id)
                .then(resource => JSON.parse(resource?.value || ''));
        }

        return api
            .model('TransformerResource')
            .findById(id, { virtuals: true })
            .then(resource => resource?.value);
    },
});

const fetchDocument = memoizeExpire({
    timeout: 60e3,
    resolver: (...args: any[]) => args.join('__'),
    func: (model: any, id: string) => api.model(model).findById(id),
});

const fetchDocumentByQuery = memoizeExpire({
    timeout: 60e3,
    resolver: (...args: any[]) => args.join('__'),
    func: async (model: any, query: any) => {
        return api.model(model).findOne({ query: query });
    },
});

const fetchAttributeSchema = memoizeExpire({
    timeout: 60e3,
    func: (type: string) =>
        api
            .model('Pv2AttributeDefinition')
            .findOne({ query: { type }, select: ['types', '_valueSchema'] })
            .then(result => {
                if (!result?._valueSchema) return null;

                return { schema: JSON.parse(result._valueSchema) };
            }),
});
